<template>
	<div v-if="isLeft" class="InputSearch_left">
		<div class="InputSearch_searchIcon" @click.stop="onSearch">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M9.16797 4.00033C6.3145 4.00033 4.0013 6.31352 4.0013 9.16699C4.0013 12.0205 6.3145 14.3337 9.16797 14.3337C12.0214 14.3337 14.3346 12.0205 14.3346 9.16699C14.3346 6.31352 12.0214 4.00033 9.16797 4.00033ZM2.66797 9.16699C2.66797 5.57714 5.57812 2.66699 9.16797 2.66699C12.7578 2.66699 15.668 5.57714 15.668 9.16699C15.668 12.7568 12.7578 15.667 9.16797 15.667C5.57812 15.667 2.66797 12.7568 2.66797 9.16699Z"
					fill="#FF5E00"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M12.8632 12.8623C13.1236 12.6019 13.5457 12.6019 13.806 12.8623L17.1394 16.1956C17.3997 16.4559 17.3997 16.878 17.1394 17.1384C16.879 17.3987 16.4569 17.3987 16.1966 17.1384L12.8632 13.8051C12.6029 13.5447 12.6029 13.1226 12.8632 12.8623Z"
					fill="#FF5E00"
				/>
			</svg>
		</div>
		<input
			ref="refInput"
			class="c_input"
			type="search"
			:value="modelValue"
			:placeholder="LABEL_SEARCH_STOCK"
			v-bind="$attrs"
			@input="(event) => emit('update:modelValue', (event.target as HTMLInputElement).value)"
		/>
		<slot></slot>
		<div v-if="modelValue || $attrs.value" class="InputSearch_deleteIcon" @click.stop="onDelete">
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="12" cy="12" r="12" fill="#393D45" />
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M17.5655 6.43414C17.8779 6.74656 17.8779 7.2531 17.5655 7.56551L7.56551 17.5655C7.2531 17.8779 6.74656 17.8779 6.43414 17.5655C6.12172 17.2531 6.12172 16.7466 6.43414 16.4341L16.4341 6.43414C16.7466 6.12172 17.2531 6.12172 17.5655 6.43414Z"
					fill="white"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M6.43414 6.43414C6.74656 6.12172 7.2531 6.12172 7.56551 6.43414L17.5655 16.4341C17.8779 16.7466 17.8779 17.2531 17.5655 17.5655C17.2531 17.8779 16.7466 17.8779 16.4341 17.5655L6.43414 7.56551C6.12172 7.2531 6.12172 6.74656 6.43414 6.43414Z"
					fill="white"
				/>
			</svg>
		</div>
	</div>
	<div v-else class="InputSearch">
		<div class="InputSearch_searchIcon" @click.stop="onSearch">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M9.16797 4.00033C6.3145 4.00033 4.0013 6.31352 4.0013 9.16699C4.0013 12.0205 6.3145 14.3337 9.16797 14.3337C12.0214 14.3337 14.3346 12.0205 14.3346 9.16699C14.3346 6.31352 12.0214 4.00033 9.16797 4.00033ZM2.66797 9.16699C2.66797 5.57714 5.57812 2.66699 9.16797 2.66699C12.7578 2.66699 15.668 5.57714 15.668 9.16699C15.668 12.7568 12.7578 15.667 9.16797 15.667C5.57812 15.667 2.66797 12.7568 2.66797 9.16699Z"
					fill="#FF5E00"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M12.8632 12.8623C13.1236 12.6019 13.5457 12.6019 13.806 12.8623L17.1394 16.1956C17.3997 16.4559 17.3997 16.878 17.1394 17.1384C16.879 17.3987 16.4569 17.3987 16.1966 17.1384L12.8632 13.8051C12.6029 13.5447 12.6029 13.1226 12.8632 12.8623Z"
					fill="#FF5E00"
				/>
			</svg>
		</div>
		<input
			v-bind="$attrs"
			ref="refInput"
			class="c_input"
			type="search"
			:value="modelValue"
			:placeholder="LABEL_SEARCH_STOCK"
			@input="(event) => emit('update:modelValue', (event.target as HTMLInputElement).value)"
		/>
		<div v-if="modelValue || $attrs.value" class="InputSearch_deleteIcon" @click.stop="onDelete">
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="12" cy="12" r="12" fill="#393D45" />
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M17.5655 6.43414C17.8779 6.74656 17.8779 7.2531 17.5655 7.56551L7.56551 17.5655C7.2531 17.8779 6.74656 17.8779 6.43414 17.5655C6.12172 17.2531 6.12172 16.7466 6.43414 16.4341L16.4341 6.43414C16.7466 6.12172 17.2531 6.12172 17.5655 6.43414Z"
					fill="white"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M6.43414 6.43414C6.74656 6.12172 7.2531 6.12172 7.56551 6.43414L17.5655 16.4341C17.8779 16.7466 17.8779 17.2531 17.5655 17.5655C17.2531 17.8779 16.7466 17.8779 16.4341 17.5655L6.43414 7.56551C6.12172 7.2531 6.12172 6.74656 6.43414 6.43414Z"
					fill="white"
				/>
			</svg>
		</div>
	</div>
</template>

<script setup lang="ts">
// core
import { onMounted, ref, useAttrs } from 'vue';

import { LABEL_SEARCH_STOCK } from '@/constants/title';

defineOptions({
	inheritAttrs: false,
});

const props = defineProps<{
	modelValue?: string;
	isLeft?: boolean;
	isAutoFocus?: boolean;
}>();

const attrs = useAttrs();
const emit = defineEmits(['update:modelValue', 'onSearch', 'on-delete']);
const refInput = ref();
//검색 로직
const onSearch = () => {
	if (attrs.disabled || attrs.readonly) return;
	emit('onSearch');
};
//삭제 로직
const onDelete = () => {
	if (attrs.disabled || attrs.readonly) return;
	emit('update:modelValue', '');
	emit('on-delete');
};
onMounted(() => {
	if (props.isAutoFocus) refInput.value.focus();
});
</script>

<style scoped lang="scss">
.InputSearch_left {
	position: relative;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	input {
		height: 4.8rem;
		padding: 0 1rem 0 3.6rem;
		appearance: textfield;
		background-color: var(--color-bg);
		border-color: var(--color-active);
		border-radius: 0.6rem;
		color: var(--color-base-mid);
		font-weight: var(--font-w-light);
		font-size: var(--font-s-regular);
		line-height: 2.3rem;
		&:focus {
			box-shadow: none;
			color: white;
		}
	}
	.active_search {
		border-radius: 0.6rem 0.6rem 0rem 0rem;
	}
	.InputSearch_searchIcon,
	.InputSearch_deleteIcon {
		position: absolute;
		top: 50%;
		transform: translate(0, -50%);
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		aspect-ratio: 1;
		cursor: pointer;
		user-select: none;
	}
	.InputSearch_searchIcon {
		left: -0.3rem;
		svg {
			width: 48%;
			height: 48%;
			margin-right: -5%;
		}
	}
	.InputSearch_deleteIcon {
		right: 0rem;
		svg {
			width: 30%;
			height: 30%;
		}
	}
	input:read-only + .InputSearch_searchIcon,
	input:read-only + .InputSearch_deleteIcon,
	input:disabled + .InputSearch_searchIcon,
	input:disabled + .InputSearch_deleteIcon {
		cursor: default;
	}
}
.InputSearch {
	position: relative;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	input {
		height: 4.8rem;
		padding: 0.8rem 4.8rem 0.8rem 1.2rem;
		appearance: textfield;
		background-color: var(--color-bg);
		border-color: var(--color-active);
		border-radius: 0.6rem;
		color: var(--color-base-mid);
		font-weight: var(--font-w-regular);
		font-size: var(--font-s-regular);
		line-height: 2.3rem;
	}
	.InputSearch_searchIcon,
	.InputSearch_deleteIcon {
		position: absolute;
		top: 50%;
		transform: translate(0, -50%);
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		aspect-ratio: 1;
		cursor: pointer;
		user-select: none;
	}
	.InputSearch_searchIcon {
		right: 0rem;
		svg {
			width: 40%;
			height: 40%;
			margin-left: -5%;
		}
	}
	.InputSearch_deleteIcon {
		right: 0rem;
		svg {
			width: 30%;
			height: 30%;
		}
	}
	input:read-only + .InputSearch_searchIcon,
	input:read-only + .InputSearch_deleteIcon,
	input:disabled + .InputSearch_searchIcon,
	input:disabled + .InputSearch_deleteIcon {
		cursor: default;
	}
}
</style>
